var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-fullheight"},[_c('div',{attrs:{"id":"myearth"}}),_c('div',[_c('img',{attrs:{"id":"hologram-map","src":require("@/assets/hologram-map-2.svg")},on:{"load":_vm.loadScenario}})])])}
var staticRenderFns = []

export { render, staticRenderFns }